export const EVENTS = [
	{
		event_id: 1,
		title: 'Event 1',
		start: new Date(
			new Date(new Date(new Date().setHours(9)).setMinutes(0)).setDate(
				new Date().getDate() + 1
			)
		),
		end: new Date(
			new Date(new Date(new Date().setHours(10)).setMinutes(0)).setDate(
				new Date().getDate() + 1
			)
		),
		admin_id: 1,
		editable: false,
		deletable: false,
		color: '#FDEAEA',
	},
	{
		event_id: 2,
		title: 'Event 2',
		start: new Date(new Date(new Date().setHours(10)).setMinutes(0)),
		end: new Date(new Date(new Date().setHours(12)).setMinutes(0)),
		admin_id: 2,
		color: '#3EAE4D',
		editable: false,

		disabled: 'true',
	},
	{
		event_id: 5,
		title: 'City Hospital',
		start: new Date(
			new Date(new Date(new Date().setHours(10)).setMinutes(0)).setDate(
				new Date().getDate() - 2
			)
		),
		end: new Date(
			new Date(new Date(new Date().setHours(10)).setMinutes(30)).setDate(
				new Date().getDate() - 2
			)
		),
		admin_id: 2,
		color: '#F8BD1D',
		editable: false,
	},
	{
		event_id: 6,
		title: 'City Hospital',
		start: new Date(
			new Date(new Date(new Date().setHours(13)).setMinutes(0)).setDate(
				new Date().getDate() - 4
			)
		),
		end: new Date(
			new Date(new Date(new Date().setHours(14)).setMinutes(0)).setDate(
				new Date().getDate() - 4
			)
		),
		admin_id: 2,
		color: '#FE2C2C',
		editable: false,
	},
	{
		event_id: 6,
		title: 'City Hospital',
		start: new Date(
			new Date(new Date(new Date().setHours(15)).setMinutes(30)).setDate(
				new Date().getDate() - 3
			)
		),
		end: new Date(
			new Date(new Date(new Date().setHours(16)).setMinutes(0)).setDate(
				new Date().getDate() - 3
			)
		),
		admin_id: 2,
		color: '#FE2C2C',
		editable: false,
	},
];
